<template>
	<value-container v-if="view_only" :value="text" :label="label" :md="md"/>
	<component v-else :is='c_tag' :md2="md==2" :md3="md==3" :md4="md==4" :md8="md==8">
		<fs1-span><b>{{c_label || ''}}</b></fs1-span>
		<slot></slot>
		<input
			:class="text != null ? '': 'divEmpty'"
			:placeholder="placeholder"
			:value="text"
			:disabled="disabled"
			:min="min||0"
			:max="max === undefined?100:max"
			type="range"
			class="ie-range"
			v-on:input="updateInput"/>
			<value-container v-if="old_value != undefined" :value="`${old_value}${c_append_str}`" class_name="output_old_value_edit"/>
	</component>
</template>

<script>
export default {
  model: { prop: "text", event: "input" },
	props: ['text', 'label', 'disabled','md','min','max','float','tag','append_str', 'old_value','view_only'],
	computed:{
		placeholder() { return this.label ? ` Ingrese ${this.label}` : '' },
		c_label() { return this.label? this.label.replace('%', `${isNaN(parseInt(this.text))?'':this.text}${this.c_append_str}`): this.label },
		c_append_str(){ return this.append_str||'%'},
		c_tag(){ return this.tag || 'v-flex' },
	},
  methods: {
		updateInput(v) {  this.$emit('input', (this.float?parseFloat(v.target.value):parseInt(v.target.value))) || this.dev_log({v},v.target.value,this.text)} }
};
</script>
